import {
  DisplayFormErrors,
  InputField,
  ControlcenterMelcoModelsSupplier,
  VerticalForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { QueryObserverResult } from "react-query";
import { FullWidthSpace } from "melco-ui";
import { SavePublishHeader } from "../../header/SavePublishHeader";
import { DebugForm } from "../../form/DebugForm";
import { useRevertSupplier } from "../../../hooks/suppliers/useRevertSupplier";

type DisplaySupplierEditFormProps = {
  supplier: ControlcenterMelcoModelsSupplier;
  refetch: () => Promise<
    QueryObserverResult<ControlcenterMelcoModelsSupplier, unknown>
  >;
};

export const DisplaySupplierEditForm: React.FC<
  DisplaySupplierEditFormProps
> = ({ supplier, refetch }) => {
  const {
    id,
    publish_state: publishState,
    created_date: createdDate,
    updated_date: updatedDate,
    publish_date: publishDate,
    warning_list: warningList,
  } = supplier;

  const { t } = useTranslation();
  const [revertSupplier, isLoading] = useRevertSupplier(id!, refetch);

  return (
    <>
      <SavePublishHeader
        revertAction={revertSupplier}
        isCurrentlyReverting={isLoading}
        publishedState={publishState!}
        createdDate={createdDate!}
        updatedDate={updatedDate}
        publishedDate={publishDate}
        warnings={warningList ?? undefined}
      />

      <VerticalForm>
        <FullWidthSpace direction="vertical">
          <div>
            <DisplayFormErrors />

            {/* <InputField
              name="supplier_type"
              label={t("managesuppliers.form.supplier_type")}
              disabled
              readOnly
            /> */}
            <InputField name="name" label={t("managesuppliers.form.name")} />
          </div>
        </FullWidthSpace>
      </VerticalForm>

      {false && <DebugForm />}
    </>
  );
};
